import { createLogger } from "redux-logger";

export const logger = createLogger({
  predicate: (getState, action) => process.env.NODE_ENV === `development`
});


// WEBPACK FOOTER //
// ./src/store/middleware/logger.js